const o = (r) => typeof r != "object" || Array.isArray(r) || r === null ? (console.error("field has wrong type"), !1) : Object.values(r).some(
  (e) => Array.isArray(e) ? e.length : o(e)
);
export {
  o as checkAreThereFieldsErrors
};
